export enum ChatInviteStatus {
    Pending,
    Accepted,
    Declined,
}
